import * as React from "react";
import Reminder from "../Reminder/Reminder";
import { splitStrings } from "@features/utils/functions";
import AsyncImage from "@appComponents/AsyncImage/AsyncImage";
import IPersonVerificationStatus, {
  TPersonVerificationStatus,
} from "./IPersonVerificationStatus";
import NoPhotoMaleBigImage from "@images/no_photo_male_big.png";

import * as style from "./PersonVerificationStatusStyle.module.scss";
import * as reminderBtn from "../Reminder/ReminderStyles.module.scss";

class PersonVerificationStatus extends React.Component<
  IPersonVerificationStatus,
  TPersonVerificationStatus
> {
  text = "Send reminder";

  state: TPersonVerificationStatus = {
    text: this.text,
  };

  changeText = (success: boolean, message: string) => {
    if (!success) {
      this.setState({ text: message });
    } else {
      this.setState({ text: "Reminder sent" });
    }
    setTimeout(() => {
      this.setState({ text: this.text });
    }, 1000);
  };

  render() {
    const { name, verification_status, slug, avatar, owner, companySlug, id } =
      this.props;

    return (
      <div
        className={style.personContainer}
        data-cy="person-verification-status"
      >
        <a
          href={`/profile/${slug}`}
          className={style.personPicture}
          data-cy="person-image"
        >
          <AsyncImage image={avatar} fallback={NoPhotoMaleBigImage}>
            <img alt="" />
          </AsyncImage>
        </a>
        <div className={style.personDetails}>
          <a
            href={`/profile/${slug}`}
            className={style.name}
            data-cy="person-name"
          >
            {name}
          </a>
          {["incomplete", "unverified", "rejected"].includes(
            verification_status
          ) &&
            (owner ? (
              <a
                className={reminderBtn.reminderBtn}
                href={`/profile/${slug}/#account/identity_documents`}
                data-cy="person-verify-yourself"
              >
                Verify Yourself
              </a>
            ) : (
              <Reminder
                block={false}
                text={this.state.text}
                path={`/api/companies/${companySlug}/verification/collaborators/${id}/reminder`}
                callbackClick={this.changeText}
              />
            ))}
        </div>
        <div
          className={[style.personStatus, style[verification_status]].join(" ")}
          data-cy="person-status"
        >
          {splitStrings(verification_status, "_")}
        </div>
      </div>
    );
  }
}

export default PersonVerificationStatus;
